import Styles from "./style.module.scss";

export default function Radio({
  isChecked = false,
  setIsChecked = () => {},
  isError = false,
}) {
  return (
    <div
      className={`${Styles.outer} ${isChecked ? Styles.checked : ""} ${
        isError && Styles.isError
      }`}
      onClick={setIsChecked}
    >
      <div className={Styles.inner} />
    </div>
  );
}
